module.exports = __webpack_public_path__ + "img/logo.ed469673.jpeg";